/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElRow as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/row/style/css';
import { ElCol as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/col/style/css';
import { ElFormItem as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElIcon as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_6 from '~icons/ep/question-filled';
import { ElCheckboxGroup as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/checkbox-group/style/css';
import { ElCheckbox as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import { ElRadioGroup as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-52d3a524"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "width": "668px"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "ultrah5"
};
const _hoisted_3 = {
  class: "sub-title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "服务端参数修改后将立即影响线上游戏，请谨慎操作", -1));
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = ["href"];
const _hoisted_7 = {
  class: "flex flex-col marginT20"
};
const _hoisted_8 = {
  class: "flex items-center",
  style: {
    "width": "100%"
  }
};
const _hoisted_9 = {
  key: 6
};
const _hoisted_10 = {
  class: "sub-title"
};
const _hoisted_11 = {
  class: "flex flex-col marginT20"
};
const _hoisted_12 = {
  class: "flex items-center"
};
const _hoisted_13 = {
  class: "el-form-item__label"
};
const _hoisted_14 = {
  class: "flex items-center",
  style: {
    "width": "100%"
  }
};
const _hoisted_15 = {
  key: 5
};
const _hoisted_16 = {
  class: "sub-title"
};
const _hoisted_17 = {
  class: "flex flex-col"
};
const _hoisted_18 = {
  class: "flex items-center"
};
const _hoisted_19 = {
  key: 6,
  style: {
    "width": "20px",
    "margin-left": "10px"
  }
};
import MergeConf from './mergeConf.vue';
import TipsModal from '@ultra/share/components/UTipsModal/index.vue';
import { apiUsdkBatchGetGameInfo, apiUsdkGetParamConfV2 } from '@/api/usdk';
import { compareArrays, compareArraysGroup, copyText } from '@ultra/share/utils';
import { UseComProps } from './hooks';
import { useAppStore } from '@/store/modules/app';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'channelParams',
  props: {
    ...UseComProps(),
    operateType: {
      type: String,
      default: 'cancel'
    }
  },
  emits: ['ok'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const clientMerge1 = ref([]);
    const clientExtend1 = ref([]);
    const serverExtend1 = ref([]);
    const serverMerge1 = ref([]);
    const groupParam1 = ref([]);
    // 跳转文档配置
    const configTipsUrl = {
      baidu: 'https://herogames.feishu.cn/docx/UkKbdKIXSoXoY5xypRMcEo5GnSg#S8aKdasScoyMeGxgXZscrr2hnce',
      meizu: 'https://herogames.feishu.cn/docx/UkKbdKIXSoXoY5xypRMcEo5GnSg#WOQadyIecoMyw2x2xcxcQK39nRe',
      bilibili: 'https://herogames.feishu.cn/docx/UkKbdKIXSoXoY5xypRMcEo5GnSg#YAosdE2U8oGuIUxiQhAcn9xJn7f',
      huawei: 'https://herogames.feishu.cn/docx/UkKbdKIXSoXoY5xypRMcEo5GnSg#O8gEduKsAogiOKxqcUmctqBgnHb',
      vivo: 'https://herogames.feishu.cn/docx/UkKbdKIXSoXoY5xypRMcEo5GnSg#SaKUd0ewkoMqGixSmBFcqErnnWe',
      oppo: 'https://herogames.feishu.cn/docx/UkKbdKIXSoXoY5xypRMcEo5GnSg#D4CUd0UQgoiomUxSYasc2kDHnCT',
      mi: 'https://herogames.feishu.cn/docx/UkKbdKIXSoXoY5xypRMcEo5GnSg#NoOAdWgiqocyscxyIVec7OMInPg',
      ysdk: 'https://herogames.feishu.cn/docx/UkKbdKIXSoXoY5xypRMcEo5GnSg#ZeGKdCYoooWyWyx609hcYrDqnKh',
      ud: 'https://herogames.feishu.cn/docx/UkKbdKIXSoXoY5xypRMcEo5GnSg#EecedG2gYoQWUOxkZj8cpC66nbf'
    };
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    const gamePrams = ref({
      productID: '',
      productKey: '',
      callbackKey: ''
    });
    const H5url = computed(() => {
      if (props.channel.channel !== 'ultrah5') return '';
      let productId = '';
      let projectId = '';
      let serverId = '';
      let appKey = '';
      serverExtend1.value.forEach(item => {
        if (item.key === 'appkey') {
          appKey = item.value;
        }
        if (item.key === 'productId') {
          productId = item.value;
        }
        if (item.key === 'projectId') {
          projectId = item.value;
        }
        if (item.key === 'serverId') {
          serverId = item.value;
        }
      });
      return `https://h5g.ultrasdk.com/?game_id=${gamePrams.value.productID}&productId=${productId}&projectId=${projectId}&serverId=${serverId}&appKey=${appKey}`;
    });
    // 获取游戏信息
    const getGameInfo = async () => {
      const res = await apiUsdkBatchGetGameInfo({
        gids: gameInfo.value.Id
      });
      if (res.code === 0) {
        var _res$data$, _res$data$2, _res$data$3;
        gamePrams.value = {
          productID: (_res$data$ = res.data[0]) === null || _res$data$ === void 0 ? void 0 : _res$data$.productID,
          productKey: (_res$data$2 = res.data[0]) === null || _res$data$2 === void 0 ? void 0 : _res$data$2.productKey,
          callbackKey: (_res$data$3 = res.data[0]) === null || _res$data$3 === void 0 ? void 0 : _res$data$3.callbackKey
        };
      }
    };
    const copyUrl = url => {
      copyText(url).then(() => {
        ElMessage.success('复制成功!');
      });
    };
    const formatConf = configs => {
      configs.forEach(item => {
        if (item.type === 5 || item.type === 2) {
          item.defValue = item.defValue && item.defValue.split(',');
        }
        if ([3, 4, 5].includes(item.type)) {
          item.value = item.value && item.value.split(',');
        }
      });
      return configs;
    };
    // 参数配置说明
    const tipsModal = ref();
    const handleShowDesc = data => {
      var _tipsModal$value;
      (_tipsModal$value = tipsModal.value) === null || _tipsModal$value === void 0 ? void 0 : _tipsModal$value.show(data.tip);
    };
    const getDict = dataSource => {
      const dict = {};
      dataSource.map(item => {
        dict[item.key] = {
          name: item.name
        };
      });
      return dict;
    };
    const deepClientExtend1 = ref([]);
    const deepClientMerge1 = ref([]);
    const deepServerExtend1 = ref([]);
    const deepServerMerge1 = ref([]);
    const deepGroupParam1 = ref([]);
    const getParamConf = () => {
      apiUsdkGetParamConfV2({
        gid: props.gid,
        cid: props.channel && props.channel.cid,
        ccid: props.channel && props.channel.id
      }).then(res => {
        if (res.code === 0) {
          const {
            clientMerge,
            clientExtend,
            serverExtend,
            serverMerge,
            groupParam
          } = res.data;
          clientExtend1.value = formatConf(clientExtend);
          clientMerge1.value = formatConf(clientMerge);
          serverExtend1.value = formatConf(serverExtend);
          serverMerge1.value = formatConf(serverMerge);
          groupParam.forEach(item => {
            item.enable = item.enable || {
              value: 0
            };
            item.params = formatConf(item.params);
          });
          groupParam1.value = groupParam;
          deepClientExtend1.value = JSON.parse(JSON.stringify(clientExtend1.value));
          deepClientMerge1.value = JSON.parse(JSON.stringify(clientMerge1.value));
          deepServerExtend1.value = JSON.parse(JSON.stringify(serverExtend1.value));
          deepServerMerge1.value = JSON.parse(JSON.stringify(serverMerge1.value));
          deepGroupParam1.value = JSON.parse(JSON.stringify(groupParam1.value));
        }
      });
    };
    const changeEnable = (e, item) => {
      item.enable.value = e ? 1 : 0;
    };
    const formatValue = item => {
      if (item.type == 5) {
        return item.value.join(',');
      } else if (item.type == 4 || item.type == 3) {
        if (Array.isArray(item.value)) {
          const arr = item.value.map(i => {
            return i.url || i;
          });
          return arr.join(',');
        }
        return item.value;
      } else {
        return item.value;
      }
    };
    watch(() => props.operateType, val => {
      if (val === 'save') {
        handleClick();
      }
      if (val === 'cancel') {
        getParamConf();
        clientExtend1.value = JSON.parse(JSON.stringify(deepClientExtend1.value));
        clientMerge1.value = JSON.parse(JSON.stringify(deepClientMerge1.value));
        serverExtend1.value = JSON.parse(JSON.stringify(deepServerExtend1.value));
        serverMerge1.value = JSON.parse(JSON.stringify(deepServerMerge1.value));
        groupParam1.value = JSON.parse(JSON.stringify(deepGroupParam1.value));
      }
    });
    const emits = __emit;
    const handleClick = () => {
      const dict = getDict([...clientExtend1.value, ...clientMerge1.value, ...serverExtend1.value, ...serverMerge1.value, ...groupParam1.value.map(item => item.enable), ...groupParam1.value.map(item => item.params)].flat());
      const newTemp = [...clientExtend1.value, ...clientMerge1.value, ...serverExtend1.value, ...serverMerge1.value, ...groupParam1.value.map(item => item.enable), ...groupParam1.value.map(item => item.params)].flat();
      const oldTemp = [...deepClientExtend1.value, ...deepClientMerge1.value, ...deepServerExtend1.value, ...deepServerMerge1.value, ...deepGroupParam1.value.map(item => item.enable), ...deepGroupParam1.value.map(item => item.params)].flat();
      const newData = {};
      newTemp.map(item => {
        newData[item.key] = item.value;
      });
      const oldData = {};
      oldTemp.map(item => {
        oldData[item.key] = item.value;
      });
      const a = compareArrays(clientExtend1.value, deepClientExtend1.value);
      const b = compareArrays(clientMerge1.value, deepClientMerge1.value);
      const c = compareArrays(serverExtend1.value, deepServerExtend1.value);
      const d = compareArrays(serverMerge1.value, deepServerMerge1.value);
      console.log('a', a);
      console.log({
        groupParam1
      });
      const e = compareArraysGroup(groupParam1.value, deepGroupParam1.value);
      console.log({
        e
      });
      const editArr = [...a, ...b, ...c, ...d, ...e];
      let arr = [];
      let params = {
        gid: props.gid,
        cid: props.channel && props.channel.cid
      };
      const createConf = item => {
        arr.push({
          id: item.id,
          ccid: props.channel && props.channel.id,
          ctid: item.ctid,
          ctkey: item.key,
          value: formatValue(item)
        });
      };
      clientMerge1.value.forEach(c => createConf(c));
      clientExtend1.value.forEach(c => createConf(c));
      serverExtend1.value.forEach(c => createConf(c));
      serverMerge1.value.forEach(c => createConf(c));
      groupParam1.value.forEach(item => {
        item.params.forEach(c => createConf(c));
        if (item.enable) {
          createConf(item.enable);
        }
      });
      console.log({
        clientExtend1
      });
      console.log({
        arr
      });
      params.paramList = JSON.stringify(arr);
      const fn = () => {
        emits('ok', params, editArr, dict, newData, oldData);
      };
      fn();
    };
    onMounted(() => {
      getParamConf();
      getGameInfo();
      console.log(props);
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_u_question = _resolveComponent("u-question");
      const _component_el_input = __unplugin_components_1;
      const _component_el_radio = __unplugin_components_2;
      const _component_el_radio_group = __unplugin_components_3;
      const _component_u_upload = _resolveComponent("u-upload");
      const _component_el_checkbox = __unplugin_components_4;
      const _component_el_checkbox_group = __unplugin_components_5;
      const _component_i_ep_question_filled = __unplugin_components_6;
      const _component_el_icon = __unplugin_components_7;
      const _component_el_form_item = __unplugin_components_8;
      const _component_el_col = __unplugin_components_9;
      const _component_el_row = __unplugin_components_10;
      const _component_el_form = __unplugin_components_11;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_ctx.channel.channel === "ultrah5" ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createTextVNode(" 游戏地址为："), _createElementVNode("div", null, _toDisplayString(H5url.value), 1), _createVNode(_component_el_button, {
        plain: "",
        size: "small",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => copyUrl(H5url.value))
      }, {
        default: _withCtx(() => [_createTextVNode("复制")]),
        _: 1
      })])) : _createCommentVNode("", true), _createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createTextVNode("服务端参数 "), _createVNode(_component_u_question, null, {
          default: _withCtx(() => [_hoisted_4, configTipsUrl[_ctx.channel.channel] ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createTextVNode("关于如何获取服务端参数，详情见文档： "), _createElementVNode("a", {
            href: configTipsUrl[_ctx.channel.channel],
            class: "btn-color",
            style: {
              "font-size": "12px"
            },
            target: "_blank"
          }, "操作手册", 8, _hoisted_6)])) : _createCommentVNode("", true)]),
          _: 1
        })]), _createVNode(MergeConf, {
          confList: _unref(serverMerge1)
        }, null, 8, ["confList"]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(serverExtend1), item => {
          return _openBlock(), _createBlock(_component_el_form_item, {
            key: item.id,
            label: item.name
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [item.type === 1 ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              disabled: __props.operateType === 'cancel',
              placeholder: `填写${item.name}`
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])) : _createCommentVNode("", true), item.type === 2 ? (_openBlock(), _createBlock(_component_el_radio_group, {
              key: 1,
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              disabled: __props.operateType === 'cancel'
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.defValue, i => {
                return _openBlock(), _createBlock(_component_el_radio, {
                  key: i,
                  label: i
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(i), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.type === 3 ? (_openBlock(), _createBlock(_component_u_upload, {
              key: 2,
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              disabled: __props.operateType === 'cancel'
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.type === 4 ? (_openBlock(), _createBlock(_component_u_upload, {
              key: 3,
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              disabled: __props.operateType === 'cancel',
              listType: "picture-card"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.type === 5 ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
              key: 4,
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              disabled: __props.operateType === 'cancel'
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.defValue, i => {
                return _openBlock(), _createBlock(_component_el_checkbox, {
                  key: i,
                  label: i
                }, null, 8, ["label"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.tip ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 5,
              size: 20,
              class: "marginL10 cp",
              color: "#f59a23",
              onClick: $event => handleShowDesc(item)
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_question_filled)]),
              _: 2
            }, 1032, ["onClick"])) : (_openBlock(), _createElementBlock("div", _hoisted_9))])]),
            _: 2
          }, 1032, ["label"]);
        }), 128))]), _ctx.channel.plat != 2 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_10, [_createTextVNode("客户端参数 "), _createVNode(_component_u_question, {
          content: "客户端参数修改后需要重新出包才可生效"
        })]), _createVNode(MergeConf, {
          confList: _unref(clientMerge1)
        }, null, 8, ["confList"]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(clientExtend1), item => {
          return _openBlock(), _createBlock(_component_el_form_item, {
            key: item.id
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("label", _hoisted_13, _toDisplayString(item.name), 1), item.tip ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0,
              size: 20,
              class: "marginL10 cp",
              color: "#f59a23",
              onClick: $event => handleShowDesc(item)
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_question_filled)]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [item.type === 1 ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              disabled: __props.operateType === 'cancel'
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.type === 2 ? (_openBlock(), _createBlock(_component_el_radio_group, {
              key: 1,
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              disabled: __props.operateType === 'cancel'
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.defValue, i => {
                return _openBlock(), _createBlock(_component_el_radio, {
                  key: i,
                  label: i
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(i), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.type === 3 ? (_openBlock(), _createBlock(_component_u_upload, {
              key: 2,
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              disabled: __props.operateType === 'cancel'
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.type === 4 ? (_openBlock(), _createBlock(_component_u_upload, {
              key: 3,
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              disabled: __props.operateType === 'cancel',
              listType: "picture-card"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.type === 5 ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
              key: 4,
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              disabled: __props.operateType === 'cancel'
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.defValue, i => {
                return _openBlock(), _createBlock(_component_el_checkbox, {
                  key: i,
                  label: i
                }, null, 8, ["label"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : (_openBlock(), _createElementBlock("div", _hoisted_15))])]),
            _: 2
          }, 1024);
        }), 128))]), _createElementVNode("div", _hoisted_16, [_createTextVNode("三方参数 "), _createVNode(_component_u_question, {
          content: "选择需要的三方，填写对应参数"
        })]), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupParam1), items => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: items.group
          }, [_createVNode(_component_el_checkbox, {
            checked: items.enable.value == 1,
            disabled: __props.operateType === 'cancel',
            class: "marginL40",
            onChange: $event => changeEnable($event, items)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(items.group), 1)]),
            _: 2
          }, 1032, ["checked", "disabled", "onChange"]), items.enable.value == 1 ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            class: "marginT20 marginL40"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.params, item => {
              return _openBlock(), _createBlock(_component_el_col, {
                key: item.id,
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: item.name
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [item.type === 1 ? (_openBlock(), _createBlock(_component_el_input, {
                    key: 0,
                    modelValue: item.value,
                    "onUpdate:modelValue": $event => item.value = $event,
                    disabled: __props.operateType === 'cancel'
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.type === 2 ? (_openBlock(), _createBlock(_component_el_radio_group, {
                    key: 1,
                    modelValue: item.value,
                    "onUpdate:modelValue": $event => item.value = $event,
                    disabled: __props.operateType === 'cancel'
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.defValue, i => {
                      return _openBlock(), _createBlock(_component_el_radio, {
                        key: i,
                        label: i
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(i), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.type === 3 ? (_openBlock(), _createBlock(_component_u_upload, {
                    key: 2,
                    modelValue: item.value,
                    "onUpdate:modelValue": $event => item.value = $event,
                    disabled: __props.operateType === 'cancel'
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.type === 4 ? (_openBlock(), _createBlock(_component_u_upload, {
                    key: 3,
                    modelValue: item.value,
                    "onUpdate:modelValue": $event => item.value = $event,
                    disabled: __props.operateType === 'cancel',
                    listType: "picture"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.type === 5 ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                    key: 4,
                    modelValue: item.value,
                    "onUpdate:modelValue": $event => item.value = $event,
                    disabled: __props.operateType === 'cancel'
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.defValue, i => {
                      return _openBlock(), _createBlock(_component_el_checkbox, {
                        key: i,
                        label: i
                      }, null, 8, ["label"]);
                    }), 128))]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : _createCommentVNode("", true), item.tip ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 5,
                    size: 20,
                    class: "marginL10 cp",
                    color: "#f59a23",
                    onClick: $event => handleShowDesc(item)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_i_ep_question_filled)]),
                    _: 2
                  }, 1032, ["onClick"])) : (_openBlock(), _createElementBlock("div", _hoisted_19))])]),
                  _: 2
                }, 1032, ["label"])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)], 64);
        }), 128))])], 64)) : _createCommentVNode("", true)]),
        _: 1
      })]), _createVNode(TipsModal, {
        ref_key: "tipsModal",
        ref: tipsModal
      }, null, 512)], 64);
    };
  }
});